import { render } from "./AssessmentTax.vue?vue&type=template&id=5ffac6ca&scoped=true"
import script from "./AssessmentTax.vue?vue&type=script&lang=js"
export * from "./AssessmentTax.vue?vue&type=script&lang=js"

import "./AssessmentTax.vue?vue&type=style&index=0&id=5ffac6ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffac6ca"]])

export default __exports__